import { Map, fromJS } from 'immutable'
import { handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import {
  TYPE_SENSOR,
  MODULE_A,
  TYPE_SATURATION,
  getDefaultWeatherObject,
  getDefaultSensorsObject,
} from 'helpers/environmentMonitor'

// constants
export const FETCH_WEATHER_DATA = 'slaMonitor/environment/FETCH_WEATHER_DATA'
export const SUCCESS_WEATHER_DATA =
  'slaMonitor/environment/SUCCESS_WEATHER_DATA'
export const FAILURE_WEATHER_DATA =
  'slaMonitor/environment/FAILURE_WEATHER_DATA'
export const FETCH_SENSORS_DATA = 'slaMonitor/environment/FETCH_SENSORS_DATA'
export const SUCCESS_SENSORS_DATA =
  'slaMonitor/environment/SUCCESS_SENSORS_DATA'
export const FAILURE_SENSORS_DATA =
  'slaMonitor/environment/FAILURE_SENSORS_DATA'
export const SET_MODULE = 'slaMonitor/environment/SET_MODULE'
export const SET_TYPE = 'slaMonitor/environment/SET_TYPE'
export const SET_SHOW_CHART_MODAL =
  'slaMonitor/environment/SET_SHOW_CHART_MODAL'
export const SET_CHART_TYPE = 'slaMonitor/environment/SET_CHART_TYPE'

// actions
export const fetchWeatherData = ActionHelper.createActionObj(FETCH_WEATHER_DATA)
export const fetchSensorsData = ActionHelper.createActionObj(FETCH_SENSORS_DATA)
export const setEnvironmentModule = ActionHelper.createActionObj(SET_MODULE)
export const setEnvironmentType = ActionHelper.createActionObj(SET_TYPE)
export const setShowChartModal = ActionHelper.createActionObj(
  SET_SHOW_CHART_MODAL,
)
export const setChartType = ActionHelper.createActionObj(SET_CHART_TYPE)

// store
const initialState = fromJS({
  isShowChartModal: false,
  chartType: TYPE_SATURATION,
  module: MODULE_A,
  type: TYPE_SENSOR,
  weatherData: getDefaultWeatherObject(),
  sensorsData: getDefaultSensorsObject(),
})

export default handleActions(
  {
    [SET_MODULE]: (state, action) => state.set('module', action.payload.module),
    [SET_TYPE]: (state, action) => state.set('type', action.payload.type),
    [SET_SHOW_CHART_MODAL]: (state, action) =>
      state.set('isShowChartModal', Boolean(action.payload)),
    [SET_CHART_TYPE]: (state, action) => state.set('chartType', action.payload),
    [SUCCESS_WEATHER_DATA]: (state, action) =>
      state.set('weatherData', Map(action.payload)),
    [FAILURE_WEATHER_DATA]: state =>
      state.set('weatherData', Map(getDefaultWeatherObject())),
    [SUCCESS_SENSORS_DATA]: (state, action) =>
      state.set('sensorsData', Map(action.payload)),
    [FAILURE_SENSORS_DATA]: state =>
      state.set('sensorsData', Map(getDefaultSensorsObject())),
  },
  initialState,
)
